import "./Downloads.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import DownloadsHero from "./sections/DownloadsHero";
import Resources from "./sections/Resources";
import DownloadSupport from "./sections/DownloadSupport";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function DownloadsPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="Downloads" />
      <DownloadsHero />
      <Resources />
      <DownloadSupport />
      <Consultation />
      <Footer />
    </div>;
}